import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, CircularProgress, TextField } from '@mui/material';
import axios from 'axios';
import { primaryColor } from '../theme';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';

const AllLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [filteredLogs, setFilteredLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const userId = JSON.parse(localStorage.getItem('user')).id;

        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/recent-activity-logs`, {
          params: { userId }
        });
        setLogs(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching logs:', error);
        setLoading(false);
      }
    };

    fetchLogs();
  }, []);

  useEffect(() => {
    const filtered = logs.filter(log =>
      log.User.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
      log.User.role.toLowerCase().includes(searchText.toLowerCase()) ||
      log.activity.toLowerCase().includes(searchText.toLowerCase()) ||
      new Date(log.date).toLocaleString().toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredLogs(filtered);
  }, [searchText, logs]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleExport = () => {
    const exportData = logs.map((log, index) => ({
        User: log.User.firstName,
        Role: log.User.role,
        Activity: log.activity,
        Date: new Date(log.date).toLocaleString(),
      }));
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Logs');
    XLSX.writeFile(workbook, 'Logs.xlsx');
  };

  const columns = [
    { name: 'No.', selector: (row, index) => (currentPage - 1) * perPage + index + 1, width: '60px' },
    { name: 'User', selector: row => row.User.firstName, sortable: true },
    { name: 'Role', selector: row => row.User.role, sortable: true },
    { name: 'Activity', selector: row => row.activity, sortable: true },
    { name: 'Date', selector: row => new Date(row.date).toLocaleString(), sortable: true },
  ];

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h4" gutterBottom style={{ color: primaryColor }}>
            All Logs
        </Typography>
        <Button variant="contained" color="primary" onClick={handleExport} sx={{ mb: 2 }}>
            Export Logs
        </Button>
        </Box>
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <DataTable
        columns={columns}
        data={filteredLogs}
        pagination
        paginationPerPage={perPage}
        paginationRowsPerPageOptions={[10, 20, 30, 50]}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
        highlightOnHover
        pointerOnHover
        responsive
        customStyles={{
          headCells: {
            style: {
              backgroundColor: primaryColor,
              color: '#fff',
              fontSize: '16px',
              fontWeight: 'bold',
            },
          },
          cells: {
            style: {
              borderBottom: '1px solid rgba(224, 224, 224, 1)',
            },
          },
        }}
      />
    </Container>
  );
};

export default AllLogsPage;